import { BsFilter } from "react-icons/bs";
import DropdownButton from "../DropdownButton";
import FiltersDropdown, { FilterValues } from "./FiltersDropdown";
import { useMemo } from "react";

interface FilterButtonProps {
  onFilterChange?: (filters: FilterValues) => void;
}

export default function FilterButton({ onFilterChange }: FilterButtonProps) {
  // Memoize the FiltersDropdown component to prevent re-creation on each render
  const filtersDropdownContent = useMemo(() => {
    const handleFilterChange = (filters: FilterValues) => {
      if (onFilterChange) {
        onFilterChange(filters);
      }
    };
    
    return <FiltersDropdown onFilterChange={handleFilterChange} />;
  }, [onFilterChange]);

  return (
    <DropdownButton 
      icon={<BsFilter />} 
      text={"Filters"} 
      dropdownContent={filtersDropdownContent} 
      endAlign={true} 
    />
  );
}
